import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ui-input-card__item" }
const _hoisted_2 = {
  key: 0,
  class: "ui-input-card__error",
  "data-error": "true"
}

import { computed, onMounted, ref, watch, nextTick } from 'vue'
import { isNumber } from '@/common/helpers'

// Use
import { useVModel } from '@vueuse/core'

// Store
import { useCommonStore } from '@/store'
import InputText from '@/components/inputs/InputText'

// Types
import type { Props } from './index'
import { IdType } from '@/common/types'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'InputCard',
  props: {
    label: {},
    placeholder: {},
    name: {},
    modelValue: {},
    value: {},
    hint: {},
    mask: {},
    error: {}
  },
  emits: ["update:modelValue", "update:error"],
  setup(__props: any, { emit: __emit }) {

const commonStore = useCommonStore()

// Components
const props = __props

// Emits
const emit = __emit

// Data
let model = useVModel(props, 'modelValue', emit)
const proxiedError = useVModel(props, 'error', emit)
const card = ref<string | number>(props.value ?? '')
const display = ref<boolean>(Boolean(card.value === 'new'))

// Computed
const text = computed<string | null>(() => props.placeholder ?? props.label ?? null)


// Methods
function clearError(): void {
  proxiedError.value = null
}

function checkValue(id: IdType): void {
  const card = commonStore.user?.cards?.find(item => item.id === id)
  if (!card) {
    model.value = ''
  }
}

function setActive() {
  if (typeof model.value != 'number') {
    const active = commonStore.user?.cards?.find(item => item.active)
    card.value = active?.id ?? ''
  }
}

onMounted(() => {
  if (props.value) {
    model.value = props.value
    checkValue(props.value)
    nextTick(() => {
      setActive()
    })
  }
})


watch(card, (val) => {
  if (val === 'new') {
    display.value = true
    nextTick(() => {
      model.value = ''
    })
  } else {
    display.value = false
    model.value = val
  }
})

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (!_unref(commonStore).user?.cards.length)
    ? (_openBlock(), _createBlock(_unref(InputText), _mergeProps({
        key: 0,
        modelValue: _unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
      }, props, {
        "model-error": _unref(proxiedError),
        theme: "inTask"
      }), null, 16, ["modelValue", "model-error"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "ui-input-card",
        onClick: clearError
      }, [
        _createVNode(_component_el_radio_group, {
          modelValue: card.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((card).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonStore).user.cards, (card) => {
              return (_openBlock(), _createBlock(_component_el_radio, {
                label: card.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (card.paymentSystem)
                      ? (_openBlock(), _createBlock(_component_draw_svg, {
                          key: 0,
                          name: `${card.paymentSystem}-color`,
                          width: "25",
                          height: "25"
                        }, null, 8, ["name"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(card.number), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 256)),
            _createVNode(_component_el_radio, { label: "new" }, {
              default: _withCtx(() => [
                (display.value)
                  ? (_openBlock(), _createBlock(_unref(InputText), _mergeProps({
                      key: 0,
                      modelValue: _unref(model),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event))
                    }, props, {
                      placeholder: "",
                      theme: "inTask",
                      error: null,
                      focus: ""
                    }), null, 16, ["modelValue"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('profile.newCard')), 1)
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_unref(proxiedError))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(proxiedError)), 1))
          : _createCommentVNode("", true)
      ]))
}
}

})